import { Button } from '@tovala/component-library'
import { events, sourceIDs } from 'analytics/events'
import MoonIcon from 'components/common/icons/MoonIcon'
import { useUser } from 'contexts/user'
import { track } from 'utils/analytics'
import ResumeDeliveries from '../account/ResumeDeliveries'

const OnBreakOrderStatus = () => {
  const { user } = useUser()

  return (
    <div className="space-y-4">
      <div className="flex items-center justify-between">
        <div className="flex items-center space-x-2">
          <div className="h-4 w-4 text-orange-1">
            <MoonIcon />
          </div>

          <span className="text-k/20_110">Paused</span>
        </div>

        <ResumeDeliveries userID={user.id}>
          {({ onClickResume }) => (
            <div className="h-11 w-[183px] text-k/14_120 md:h-9">
              <Button
                onClick={() => {
                  track(events.ORDERS_TAPPED_RESUME_DELIVERIES, {
                    source_id: sourceIDs.MENU_TERM,
                  })

                  onClickResume()
                }}
                size="fluid"
              >
                Resume Deliveries
              </Button>
            </div>
          )}
        </ResumeDeliveries>
      </div>
    </div>
  )
}

export default OnBreakOrderStatus
